module.exports = __webpack_public_path__ + "img/74_19.08fbe920.png";